import { Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { Subject } from 'rxjs/Subject';
import { Modal } from '../modal/Modal';
import { debounceTime, distinctUntilChanged, switchMap } from 'rxjs/operators';
import { forkJoin } from 'rxjs';
import { Subscription } from 'rxjs/Subscription';
import { StorageService } from '../../services/storage.service';
import { EstablishmentsService } from '../../services/establishments.service';
import { UserService } from '../../services/user.service';
import * as _ from 'lodash';
import { of } from 'rxjs/observable/of';
import { IEstablishment } from '../../interfaces/establishment';

@Component({
  selector: 'app-search-establishment-modal',
  templateUrl: './search-establishment-modal.component.html',
  styleUrls: ['./search-establishment-modal.component.scss']
})
export class SearchEstablishmentModalComponent implements OnInit, OnDestroy {

  @ViewChild('modal') modal: Modal;
  @ViewChild('inputSearch') inputSearch: HTMLInputElement;

  @Input() establishmentId: string;
  @Output() selectItem = new EventEmitter();

  establishment: IEstablishment;
  keyUpSearch = new Subject<KeyboardEvent>();
  subscription: Subscription;
  loggedAccount;
  searchResult: IEstablishment[];
  query = '';
  loading;
  location;

  constructor(
    private storage: StorageService,
    private establishmentsService: EstablishmentsService,
    private userService: UserService,
  ) {
    this.loggedAccount = this.userService.getLoggedAccount();
    this.subscription = this.getSearchSubscription();
  }

  ngOnInit() {
    this.getLocation();

    if (this.establishmentId && !this.establishment) {
      this.getEstablishment(this.establishmentId);
    }
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }

  getSearchSubscription() {
    return this.keyUpSearch.pipe(
      debounceTime(1000),
      distinctUntilChanged(),
      switchMap(value => value ? forkJoin(this.searchObservables(value)) : of(null))
    ).subscribe(result => {
      this.searchResult = result ? _.flatMap(result, (el) => el.data) : null;
      this.loading = false;
    });
  }

  searchObservables(name) {
    this.loading = true;
    const searchParams = { name, location: this.location, companyId: this.loggedAccount.id, limit: 5 };
    const nearOnlineObservable = this.establishmentsService.searchByName(searchParams);

    return [nearOnlineObservable];
  }

  onSelectSearchItem(establishment) {
    this.modal.close();
    this.selectItem.emit(establishment.id);
    this.establishment = establishment;
    this.query = '';
    this.keyUpSearch.next();
  }

  getEstablishment(id) {
    this.establishmentsService.getEstablishmentInfo(id).then(result => {
      this.establishment = result;
    });
  }

  removeEstablishment() {
    this.establishment = null;
    this.selectItem.emit('');
  }

  getLocation() {
    if (this.storage.get('currentLocation')) {
      this.onSuccessGetLocation(this.storage.get('currentLocation'));
    }

    navigator.geolocation.getCurrentPosition(
      this.onSuccessGetLocation,
      this.onFailedGetLocation
    );
  }

  onSuccessGetLocation = (positions) => {
    if (positions) {
      this.location = (typeof positions === 'string') ? positions : `${positions.coords.latitude},${positions.coords.longitude}`;
      this.storage.set('currentLocation', this.location);
    }
  }

  onFailedGetLocation = () => {
    this.location = '-23.550717,-46.608708'; // Default location
    this.storage.remove('currentLocation');
  }
}
